import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store/index'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routeList = [
  {path: '/', name: 'Home', requiresAuth: true, comp: Home},
  {path: '/orders', name: 'Orders', requiresAuth: true, comp: () => import('../views/Order.vue')},
  {path: '/orders/:batch/:action', name: 'Edit Order', requiresAuth: true, comp: () => import('../views/Order.vue')},
  {path: '/requestprod', name: 'Request Produksi 2', requiresAuth: true, comp: () => import('../views/RequestProd.vue')},
  {path: '/penerimaanrequestprod', name: 'List Produksi', requiresAuth: true, comp: () => import('../views/PenerimaanRequestProd.vue')},
  {path: '/penerimaanrequeststock', name: 'Penerimaan Request Stock', requiresAuth: true, comp: () => import('../views/PenerimaanRequestStock.vue')},
  {path: '/inputhasilproduksi/:prod_no', name: 'Input Hasil Produksi', requiresAuth: true, comp: () => import('../views/InputHasilProduksi.vue')},
  {path: '/viewhasilproduksi/:prod_no', name: 'View Hasil Produksi', requiresAuth: true, comp: () => import('../views/ViewHasilProduksi.vue')},
  {path: '/users', name: 'Users', requiresAuth: true, comp: () => import('../views/User.vue')},
  {path: '/roles', name: 'Roles', requiresAuth: true, comp: () => import('../views/Role.vue')},
  {path: '/suppliers', name: 'Suppliers', requiresAuth: true, comp: () => import('../views/Supplier.vue')},
  {path: '/customers', name: 'Customers', requiresAuth: true, comp: () => import('../views/Customer.vue')},
  {path: '/crew', name: 'Crew', requiresAuth: true, comp: () => import('../views/Crew.vue')},
  {path: '/training', name: 'Training', requiresAuth: true, comp: () => import('../views/Training.vue')},
  {path: '/refrigerator', name: 'Refigerator', requiresAuth: true, comp: () => import('../views/Refrigerator.vue')},
  {path: '/outletrefrigerator', name: 'Outlet Refigerator', requiresAuth: true, comp: () => import('../views/OutletRefrigerator.vue')},
  {path: '/shift', name: 'Shift', requiresAuth: true, comp: () => import('../views/Shift.vue')},
  {path: '/volumelabel', name: 'Volume Label', requiresAuth: true, comp: () => import('../views/VolumeLabel.vue')},
  {path: '/shiftschedule', name: 'Shift Schedule', requiresAuth: true, comp: () => import('../views/ShiftSchedule.vue')},
  {path: '/categories', name: 'Categories', requiresAuth: true, comp: () => import('../views/Category.vue')},
  {path: '/rawmaterials', name: 'Raw Materials', requiresAuth: true, comp: () => import('../views/RawMaterial.vue')},
  {path: '/variants', name: 'Variants', requiresAuth: true, comp: () => import('../views/Variant.vue')},
  {path: '/variantjuice', name: 'Variant Juice', requiresAuth: true, comp: () => import('../views/VariantJuice.vue')},
  {path: '/menus', name: 'Menus', requiresAuth: true, comp: () => import('../views/Menu.vue')},
  {path: '/instock', name: 'InStock', requiresAuth: true, comp: () => import('../views/InStock.vue')},
  {path: '/defectstock', name: 'DefectStock', requiresAuth: true, comp: () => import('../views/DefectStock.vue')},
  {path: '/permissions', name: 'Permissions', requiresAuth: true, comp: () => import('../views/Permission.vue')},
  {path: '/misccodes', name: 'Misc Codes', requiresAuth: true, comp: () => import('../views/MiscCode.vue')},
  {path: '/ordercategories', name: 'Order Categories', requiresAuth: true, comp: () => import('../views/OrderCategory.vue')},
  {path: '/planningprod', name: 'Planning Produksi', requiresAuth: true, comp: () => import('../views/PlanningProd.vue')},
  {path: '/orderplanningprod', name: 'Create Order', requiresAuth: true, comp: () => import('../views/OrderPlanningProd.vue')},
  {path: '/uploadorderplan/:batch/:order_id', name: 'Create Order Planning Produksi', requiresAuth: true, comp: () => import('../views/UploadOrderPlan.vue')},
  {path: '/vieworderplan/:batch/:order_id', name: 'View Order Planning Produksi', requiresAuth: true, comp: () => import('../views/ViewOrderPlan.vue')},
  {path: '/requestlogisticdetail/:batch/:order_id', name: 'Order Planning Produksi', requiresAuth: true, comp: () => import('../views/RequestLogisticDetail.vue')},
  {path: '/requestplanningprod/:batch', name: 'Request Produksi', requiresAuth: true, comp: () => import('../views/RequestPlanningProd.vue')},
  {path: '/requestlogistic/:batch', name: 'Request Logistik', requiresAuth: true, comp: () => import('../views/RequestLogistic.vue')},
  {path: '/listhasilproduksi', name: 'List Hasil Produksi', requiresAuth: true, comp: () => import('../views/ListHasilProduksi.vue')},
  {path: '/deliveryorder', name: 'Delivery Order', requiresAuth: true, comp: () => import('../views/DeliveryOrder.vue')},
  {path: '/machine', name: 'Machine', requiresAuth: true, comp: () => import('../views/Machine.vue')},
  {path: '/packagingcost', name: 'Packaging Cost', requiresAuth: true, comp: () => import('../views/PackagingCost.vue')},
  {path: '/stockopname/:type', name: 'Stock Opname', requiresAuth: true, comp: () => import('../views/StockOpname.vue')},
  {path: '/stockopnamefg/:type', name: 'Stock Opname', requiresAuth: true, comp: () => import('../views/StockOpnameFG.vue')},
  {path: '/reports/frm003', name: 'Frm 003', requiresAuth: true, comp: () => import('../views/RptFrm003.vue')},
  {path: '/reports/frm005', name: 'Frm 005', requiresAuth: true, comp: () => import('../views/RptFrm005.vue')},
  {path: '/reports/production/:type', name: 'Report Production', requiresAuth: true, comp: () => import('../views/RptProduction.vue')},
  {path: '/reports/cost', name: 'Report Hitungan Cost', requiresAuth: true, comp: () => import('../views/RptCost.vue')},
  {path: '/reports/frmlogistik', name: 'Form Logistik', requiresAuth: true, comp: () => import('../views/RptFrmLogistik.vue')},
  {path: '/callcenter', name: 'Call Centers', requiresAuth: true, comp: () => import('../views/CallCenter.vue')},
  {path: '/operationalteam', name: 'Operational Teams', requiresAuth: true, comp: () => import('../views/OperationalTeam.vue')},
  {path: '/productcategory', name: 'Product Categories', requiresAuth: true, comp: () => import('../views/ProductCategory.vue')},
  {path: '/outletcategory', name: 'Outlet Categories', requiresAuth: true, comp: () => import('../views/OutletCategory.vue')},
  {path: '/coordinator', name: 'Coordinators', requiresAuth: true, comp: () => import('../views/Coordinator.vue')},
  {path: '/outlet', name: 'Outlets', requiresAuth: true, comp: () => import('../views/Outlet.vue')},
  {path: '/outlet/create/:outlet_code', name: 'Add Outlet', requiresAuth: true, comp: () => import('../views/OutletCreate.vue')},
  {path: '/outlet/detail/:outlet_code', name: 'Outlet Detail', requiresAuth: true, comp: () => import('../views/OutletDetail.vue')},
  {path: '/vehicle', name: 'Vehicles', requiresAuth: true, comp: () => import('../views/Vehicle.vue')},
  {path: '/po', name: 'Purchase Orders', requiresAuth: true, comp: () => import('../views/Po.vue')},
  {path: '/po/form/:outlet_code', name: 'Purchase Order Details', requiresAuth: true, comp: () => import('../views/POForm.vue')},
  {path: '/po/view/:outlet_code', name: 'Purchase Order View', requiresAuth: true, comp: () => import('../views/POForm.vue')},
  {path: '/detail-planning', name: 'Detail Planning', requiresAuth: true, comp: () => import('../views/DetailPlanning.vue')},
  {path: '/detail-planning/form/:outlet_code/:action', name: 'Detail Planning Detail', requiresAuth: true, comp: () => import('../views/DetailPlanningForm.vue')},
  {path: '/closing-outlet', name: 'Closing Outlet', requiresAuth: true, comp: () => import('../views/ClosingOutlet.vue')},
  {path: '/daily-check', name: 'Daily Check', requiresAuth: true, comp: () => import('../views/DailyCheck.vue')},
  {path: '/mass-production', name: 'Production', requiresAuth: true, comp: () => import('../views/MassProduction.vue')},
  {path: '/mass-production/:code', name: 'Production Detail', requiresAuth: true, comp: () => import('../views/MassProductionCreate.vue')},
  {path: '/tabel-bantuan', name: 'Tabel Bantuan', requiresAuth: true, comp: () => import('../views/Bantuan.vue')},
  {path: '/tabel-bantuan/:code', name: 'Tabel Bantuan Detail', requiresAuth: true, comp: () => import('../views/BantuanDetail.vue')},
  {path: '/tabel-bantuan/view/:code', name: 'Tabel Bantuan View', requiresAuth: true, comp: () => import('../views/BantuanView.vue')},
  {path: '/tester', name: 'Tester', requiresAuth: true, comp: () => import('../views/Tester.vue')},
  {path: '/tester/view/:id', name: 'Tester View', requiresAuth: true, comp: () => import('../views/TesterView.vue')},
  {path: '/tester/:id', name: 'Tester Detial', requiresAuth: true, comp: () => import('../views/TesterDetail.vue')},
  {path: '/pembagian-koordinator', name: 'Pembagian Koordinator', requiresAuth: true, comp: () => import('../views/PembagianKoordinator.vue')},
  {path: '/reports/expired-logistik', name: 'Expired Logistik', requiresAuth: true, comp: () => import('../views/RptExpiredLogistik.vue')},
  {path: '/reports/summary-tester', name: 'Summary Tester', requiresAuth: true, comp: () => import('../views/TesterSummary.vue')},
  {path: '/reports/summary-report-po', name: 'Summary Report PO', requiresAuth: true, comp: () => import('../views/RptSummaryPO.vue')},
  {path: '/variants-sort', name: 'Variants Sort', requiresAuth: true, comp: () => import('../views/VariantSort.vue')},
  {path: '/holiday', name: 'Hari Libur', requiresAuth: true, comp: () => import('../views/Holiday.vue')},
  {path: '/reports/actual-po', name: 'Aktualiasi PO', requiresAuth: true, comp: () => import('../views/RptActualPO.vue')},
  {path: '/master-data-menu', name: 'Master Data Menu', requiresAuth: true, comp: () => import('../views/MasterDataMenu.vue')},
  {path: '/master-data-menu/view/:code', name: 'Master Data Menu View', requiresAuth: true, comp: () => import('../views/MasterDataMenuView.vue')},
  {path: '/master-data-menu/:id', name: 'Master Data Menu Detail', requiresAuth: true, comp: () => import('../views/MasterDataMenuDetail.vue')},
  {path: '/reports/sales-tester', name: 'Report Sales - Tester', requiresAuth: true, comp: () => import('../views/RptSales.vue')},
  {path: '/coordinator-production', name: 'Koordinator Produksi', requiresAuth: true, comp: () => import('../views/CoordinatorProduction.vue')},
  {path: '/reports/summary-area-manager', name: 'Summary Area Manager', requiresAuth: true, comp: () => import('../views/RptSumAreaManager.vue')},
  {path: '/reports/summary-po-koordinator', name: 'Summary PO per Koordinator', requiresAuth: true, comp: () => import('../views/RptSummaryPOKoordinator.vue')},
  {path: '/reports/tester-detail', name: 'Tester Detail', requiresAuth: true, comp: () => import('../views/RptTesterDetail.vue')},
  {path: '/reports/jalur-outlet', name: 'Jalur Outlet', requiresAuth: true, comp: () => import('../views/RptJalurOutlet.vue')},  
  {path: '/reports/po-per-outlet', name: 'Jalur Outlet', requiresAuth: true, comp: () => import('../views/RptPOPerOutlet.vue')},  
  {path: '/reports/ambil-stok-adelphi', name: 'Ambil Stok Adelphi', requiresAuth: true, comp: () => import('../views/RptAmbilStokAdelphi.vue')},  
  {path: '/po-control', name: 'PO Control', requiresAuth: true, comp: () => import('../views/POControl.vue')},  
  {path: '/pembagian-koordinator-lk', name: 'Pembagian Koordinator LK', requiresAuth: true, comp: () => import('../views/PembagianKoordinatorLK.vue')},  
  {path: '/reports/jadwal-kirim-lk', name: 'Jadwal Kirim LK', requiresAuth: true, comp: () => import('../views/RptJadwalKirimLK.vue')},  
  {path: '/reports/delivery-order', name: 'Delivery Order', requiresAuth: true, comp: () => import('../views/RptDeliveryOrder.vue')},  
]

let routes = [
  {
    path: '/login',
    name: 'Login',
    meta: {
      requiresVisitor: true,
      layout: 'layout-login'
    },
    component: () => import('../views/Login.vue')
  }  
]
routeList.forEach(el => {
  routes.push(
    {
      path: el.path,
      name: el.name,
      meta: {
        requiresAuth: el.requiresAuth
      },
      component: el.comp
    }  
  )
})

const router = new VueRouter({
  // mode: 'history',
  routes
})

router.beforeEach(async (to, from, next) => {
  // console.log(to, from)
  if (to.matched.some(record => record.meta.requiresAuth)) {

    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (!store.getters.loggedIn) {
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      })
    } else {
      console.log(to)
      if (to.path == '/') {
        next()
        return
      }
      // Check if the user has access to the menu
      if (store.state.menu.objs.length==0) {
        await store.dispatch('menu/getObjs')
      }
      if (store.state.profile.role == undefined) {
        await store.dispatch('getProfile')
      }
      const privMenu = JSON.parse(store.state.profile.role.menu_id)
      const currentMenu = store.state.menu.objs.find(el => el.menu_url==to.path)
      console.log(currentMenu)


      if (currentMenu==undefined) {
        next()
        return
      }

      if(privMenu.includes(currentMenu.id)==false){
        return
      }
      // end
      const createMenu = JSON.parse(store.state.profile.role.create_priv)
      const updateMenu = JSON.parse(store.state.profile.role.update_priv)
      const deleteMenu = JSON.parse(store.state.profile.role.delete_priv)
      store.commit('setCurrentPagePriv', {
        create: createMenu.includes(currentMenu.id),
        update: updateMenu.includes(currentMenu.id),
        delete: deleteMenu.includes(currentMenu.id),
      })
  
      next()
    }
  } else {
    next() // make sure to always call next()!
  }
})

export default router
